import React from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import './index.css'

import ErrorPage from "./error-page";

import Index from "./routes";

import Root from './routes/root'

import {default as StudyIndex, 
  loader as studysLoader,
}  from './routes/studies/index';
import Study, {loader as studyLoader} from "./routes/studies/study";

import {default as StudyCreate, loader as studyCreateLoader, action as createStudyAction} from "./routes/studies/create";

import {default as ParticipantIndex, loader as participantLoader} from './routes/participants/index'

import {default as ParticipantUpload, loader as participantUploadLoader, action as uploadParticipantsAction} from './routes/participants/upload'

import {default as ParticipantDetail, loader as participantDetailLoader} from './routes/participants/components/ParticipantDetail'



import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
import Unauthorized from "./routes/utils/unauthorized";
import {PrivateRoute, PrivateLoader} from "./utils/private-route";
import Login from "./routes/utils/login";

const oidcConfig = {
  authority: window?.__RUNTIME_CONFIG__?.authority,
  client_id: window?.__RUNTIME_CONFIG__?.client_id,
  redirect_uri: window?.__RUNTIME_CONFIG__?.redirect_uri,
  loadUserInfo: true,
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: false,
  accessTokenExpiringNotificationTimeInSeconds: 60,
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    children: [
      { index: true, element: <Index /> },
      {
        path: "studies",
        element: <PrivateRoute redirect_login={true}><StudyIndex /></PrivateRoute>,
        loader: studysLoader,
        errorElement: <ErrorPage />
      },
      {
        path: "studies/:studyId",
        element: <PrivateRoute redirect_login={true}><Study /></PrivateRoute>,
        loader: studyLoader,
        errorElement: <ErrorPage />
      },
      {
        path: "studies/create",
        element:  <PrivateRoute redirect_login={true}><StudyCreate /></PrivateRoute>,
        loader: studyCreateLoader,
       //action: createStudyAction,
        errorElement: <ErrorPage />
      },
      {
        path: "studies/edit/:studyId",
        element: <PrivateRoute redirect_login={true}><StudyCreate /></PrivateRoute>,
        loader: studyCreateLoader,
        errorElement: <ErrorPage />
      },
      {
        path: "studies/:studyId/participants/:participantId",
        element: <PrivateRoute redirect_login={true}><ParticipantDetail /></PrivateRoute>,
        loader: participantDetailLoader,
        errorElement: <ErrorPage />
      },
      {
        path: "studies/:studyId/participants/upload",
        element: <PrivateRoute redirect_login={true}><ParticipantUpload /></PrivateRoute>,
        loader: participantUploadLoader,
        action: uploadParticipantsAction,
        errorElement: <ErrorPage />
      },
      {
        path: "unauthorized",
        element: <Unauthorized />,
      },
      {
        path: "login",
        element: <Login />,
      },
    ]
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <AuthProvider {...oidcConfig}>
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  </AuthProvider>
);